export enum AutomationType {
    Automatic = 'auto',
    Manual = 'manual',
}
